import React from "react";

interface Props {
  rank?: string;
  suit?: string;
  dragging?: boolean;
  small?: boolean;
  xsmall?: boolean;
  glowing?: boolean;
}

export const suitSymbols: { [suit: string]: string } = {
  diamonds: "♦",
  clubs: "♣",
  hearts: "♥",
  spades: "♠",
};

const glowStyle = { boxShadow: "0 0 14px 5px rgba(253, 224, 71, 0.9), 0 0 4px 1px rgba(253, 224, 71, 0.6)" };

const Card: React.FC<Props> = ({ rank, suit, dragging, small, xsmall, glowing }) => {
  if (xsmall) {
    return (
      <div
        className={`transform rotate-0 text-center rounded leading-none bg-white shadow-md border border-gray-200 ${
          suit === "diamonds" || suit === "hearts"
            ? "text-red-600"
            : "text-black"
        } text-3xl`}
        style={{
          width: "3rem",
          height: "4.2rem",
          ...(glowing ? glowStyle : {}),
        }}
      >
        <div className="grid grid-rows-2 grid-cols-2 mt-2 ml-px -space-x-1 -space-y-4">
          <div
            className={`${
              rank === "10" ? "text-2xl tracking-tighter mb-px" : ""
            }`}
          >
            {rank ? rank : "?"}
          </div>
          <div />
          <div />
          <div>{suit ? suitSymbols[suit] : "?"}</div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`transform rotate-0 grid grid-rows-3 grid-cols-3 text-center rounded leading-none bg-white shadow-md border border-gray-200 ${
        suit === "diamonds" || suit === "hearts" ? "text-red-600" : "text-black"
      } ${small ? "text-base" : "text-xl"}`}
      style={{
        width: `${small ? "4rem" : "6rem"}`,
        height: `${small ? "5.6rem" : "8.4rem"}`,
        ...(glowing ? glowStyle : {}),
      }}
    >
      <div className="grid grid-rows-2 m-auto">
        <div>{rank ? rank : "?"}</div>
        <div>{suit ? suitSymbols[suit] : "?"}</div>
      </div>
      <div className="col-span-2"></div>
      <div></div>
      <div className={`m-auto ${small ? "text-3xl" : "text-4xl"}`}>
        {suit ? suitSymbols[suit] : "?"}
      </div>
      <div className="col-span-2"></div>
      <div className="transform rotate-180 grid grid-rows-2 m-auto">
        <div>{rank ? rank : "?"}</div>
        <div>{suit ? suitSymbols[suit] : "?"}</div>
      </div>
    </div>
  );
};

export default Card;
